import { css } from "@emotion/css";
import { Dropdown, Menu, MenuItem } from "@snapchat/snap-design-system";
import { TriggerTypes } from "@snapchat/snap-design-system/lib/components/Dropdown";
import { type MenuOnClickType } from "@snapchat/snap-design-system/lib/components/Menu";
import { type FC, useCallback } from "react";
import { OSOptions } from "../types";

const options = [OSOptions.IOS, OSOptions.ANDROID];

type OsDropdownProps = {
    onSelectOs: (option: OSOptions) => void;
    selectdOs: OSOptions;
};

export const OsDropdown: FC<OsDropdownProps> = ({ onSelectOs, selectdOs }) => {
    const handleClick = useCallback((e: MenuOnClickType) => onSelectOs(e.key as OSOptions), [onSelectOs]);

    return (
        <Dropdown
            overlay={
                <Menu onClick={handleClick}>
                    {options.map((item) => (
                        <MenuItem key={item}>{item}</MenuItem>
                    ))}
                </Menu>
            }
            data-testid="app-os-selector"
            className={osDropdrown}
            buttonProps={{ label: selectdOs ?? "iOS" }}
            trigger={[TriggerTypes.CLICK]}
        />
    );
};

const osDropdrown = css`
    justify-content: space-between !important;
    min-width: 117px;
`;
